import * as model from "@/model/adm/ThreadHistory";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.ThreadHistory(), newFilter)
    .withStates({
        processDefinition: [],
        idReport: 3
    }) //TODO load at the application start
    .withActions({
        loadProcessDefinition(context){
            context.dispatch("api/get", {
                url: (context.state.baseModuleUrl +"/processDefinition/findToComboBox")
            }, 
            {root: true})
            .then(function(data){
              context.commit("setProcessDefinition", data);
            })
        }
    })
    .withMutations({
        setProcessDefinition(state, processDefinition) {
            state.processDefinition = processDefinition;
        }
    })
    .buildStore()
